export default __webpack_public_path__ + "static/media/illustr_ENG.dafd7852.svg";